import React from 'react'
import { ModalConfirm } from 'mailup-web-components'
import { useIntl } from 'react-intl'

const ModalStopSending = ({
  show,
  handleCancel,
  handleConfirm,
  appendToDataMuTest
}) => {
  const intl = useIntl()
  return (
    <ModalConfirm
      show={show}
      title={intl.formatMessage({
        id: 'Load.Schedulation.StoppingSendingConfirmTitle'
      })}
      message={intl.formatMessage(
        {
          id: 'Load.Schedulation.StoppingSendingReadyConfirmIntl'
        },
        {
          strong: chunks => <strong>{chunks}</strong>,
          linebreak: <br />
        }
      )}
      stringCancel={intl.formatMessage({ id: 'Load.MailupCommon.No' })}
      stringConfirm={intl.formatMessage({ id: 'Load.MailupCommon.Yes' })}
      onClickCancel={handleCancel}
      onClickConfirm={handleConfirm}
      data-mu-test={`modal-delete-sending-${appendToDataMuTest}`}
    />
  )
}

export default ModalStopSending
